export default {
    init() {


        this.variationFormEl = $('.variations_form')

        this.relatedProducts = $('.related-products')
        this.sliderProductReviews = $('.slider-product-reviews')
        // this.variationWrap = $('.single_variation_wrap')
        this.tabInit = false
        this.dropDownInit = false
        this.backInStock = $('#yith-wcwtl-output')
        this.productStarRating = $('.feefo-product-stars-widget')
        this.productVideoCTA = $('.product-gallery__video-cta')


        let self = this;

        if (this.variationFormEl.length) {
            this.fromPrice()
        }


        if (this.relatedProducts) {
            this.productRelatedSlider()
        }

        if (this.sliderProductReviews.length) {
            this.productReviewSlider()
        }

        if (this.backInStock.length) {
            this.backInStockRemove()
        }
        
        if (this.productStarRating.length) {
            this.productStarRatingClick()
        }

        if (this.productVideoCTA.length) {
            this.productVideoCTAClick()
        }

        $('#modal-share').on('show.bs.modal', () => {
            $('.share-buttons').find(':hidden').addBack().show()
        })

   

    },
    /* Had to change this as Vite and Woo's lifecycle are complete strangers. */
    fromPrice() {
        if (!this.variationFormEl.length) {
          console.warn('No variation form found');
          return;
        }
      
        const $form = this.variationFormEl;
        const $fromPrice = $('.single-variation_from');
        const $variationIdField = $form.find('input.variation_id');

        $('.single-variation_from').css('display', 'none'); // default variation selected

        const checkVariation = () => {
          const variationId = $variationIdField.val();
          if (variationId && variationId !== '0') {
            $fromPrice.fadeOut('fast'); // variation selected
          } else {
            $fromPrice.fadeIn('fast'); // no valid variation
          }
        };
      
        // Initial check in case defaults are set
        setTimeout(checkVariation, 100);
      
        // Watch for select or radio changes
        $form.on('change', 'select, input[type=radio]', () => {
          setTimeout(checkVariation, 100); // delay to allow Woo to update .variation_id
        });
    },
      
    productRelatedSlider() {

        this.relatedProducts.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            arrows: true,
            infinite: true,
            fade: false,
            rows: 0,
            prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev"><i class="fal fa-2x fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-arrow--next"><i class="fal fa-2x fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 564,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        })

    },
  
    productReviewSlider() {

        this.sliderProductReviews.slick({
            dots: true,
            arrows: true,
            infinite: true,
            rows: 0,
            prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev"><i class="far fa-2x fa-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-arrow--next"><i class="far fa-2x fa-angle-right"></i></button>',
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })

        // Fix for slider size / position being off when initialised inside a hidden element
        if (!this.tabInit) {
            $('a[data-toggle="tab"]').on('shown.bs.tab', () => {
                this.refreshReviewSlider()
                this.tabInit = true
            })
        }

        if (!this.dropDownInit) {
            $('a[data-toggle="collapse"]').on('shown.bs.collapse', () => {
                this.refreshReviewSlider()
                this.dropDownInit = true
            })
        }

    },
    refreshReviewSlider() {

        this.sliderProductReviews.slick('resize')
        this.sliderProductReviews.slick('setPosition')

    },
    backInStockRemove() {

        if ( $('#yith-wcwtl-output .button').text() == 'Leave waiting list' ) {
            $('#yith-wcwtl-output').hide();
        }

    },
    productStarRatingClick() {

        // Create a media condition that targets viewports at least 768px wide
        const mediaQueryDesktopUp = window.matchMedia('(min-width: 768px)')

        // Update the scrollTop target ID depending on conditional.
        if (mediaQueryDesktopUp.matches) {
            
            $('.feefo-product-stars-widget, .woocommerce-review-link').click( () => {
                $('#nav-tab-reviews').tab('show')
                $('html, body').animate({
                    scrollTop: $('#single-product-tabs').offset().top,
                }, 1000)
            })
            
        } else {

            $('.feefo-product-stars-widget, .woocommerce-review-link').click( () => {
                $('#collapse-content-reviews').addClass('show')
                $('html, body').animate({
                    scrollTop: $('#tab-reviews').offset().top,
                }, 1000)
            })

        }

    },
    productVideoCTAClick() {
        $('a[data-slide]').click(function(e) {
            e.preventDefault();
            var slideno = $(this).data('slide') -1;
            $('.product-gallery__slider--nav').slick('slickGoTo', slideno);
        });
    },
};
